export default function(key) {
  if(this.__execs__.legend) this.__execs__.legend.demute(key);
  return this;
}


// WEBPACK FOOTER //
// ./layouts/default/demuteLegend.js